export class CreateVehicleTypeModel {
  public descricao = ''
  public capacidade = 0
}

export class EditVehicleTypeModel {
  public id = 0
  public descricao = ''
  public capacidade = 0
}

export class DeleteVehicleTypeModel {
  public id = 0
  public descricao = ''
}

export class SearchVehicleTypeModel {
  public descricao = ''
}

export class CreateVehicleTypeResponse {
  public response: any
}
export class EditVehicleTypeResponse {
  public response: any
}
export class DeleteVehicleTypeResponse {
  public response: any
}
export class PagedVehicleTypeResponse {
  public response: any
}
